export default "__VITE_ASSET__a42cbd47__"